/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TitleLockupSubtitle } from '@vds/type-lockups';
import styled from 'styled-components';

import { Body } from '../Typography/index';
import { Margin } from '../styles';
import ConditionalWrapper from '../ConditionalWrapper';

const HeaderWrapper = styled.div`
  ${({ width, maxWidth }) => `
  width: ${width || ''};
  max-width: ${maxWidth || ''};
`}
`;

const SubHeading = (props) => {
  const [subHeaderText, setSubHeaderText] = useState('');
  const { totalDueTodayAmount, pageName, dueTodayText } = props;

  useEffect(() => {
    const { subHeading, isCradleFlow, cradleSubHeading = '' } = props;
    const isContactInfoPage = window.location.href.includes('contactinfo');
    if (isCradleFlow && isContactInfoPage) {
      setSubHeaderText(cradleSubHeading);
    } else setSubHeaderText(subHeading);
  }, [props.isCradleFlow]);

  const finalProps = {
    ...props,
    ...(props.subHeading
      ? {
          children: subHeaderText,
        }
      : {}),
  };
  const dispDueTodayAmount = Number(totalDueTodayAmount);
  const isShowDueTodayAmount = pageName === 'payment' && (dispDueTodayAmount || Number(dispDueTodayAmount) >= 0);

  return (
    <ConditionalWrapper useWrapper={props.width || props.maxWidth} wrapper={(children) => <HeaderWrapper {...finalProps}>{children}</HeaderWrapper>}>
      <TitleLockupSubtitle {...finalProps} />
      <Margin top="16px">
        {isShowDueTodayAmount && (
          <Body size="large" color="#6F7171">
            {' '}
            ${Number(dispDueTodayAmount)?.toFixed(2)} {dueTodayText}
          </Body>
        )}
      </Margin>
    </ConditionalWrapper>
  );
};

SubHeading.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  size: PropTypes.string,
  bold: PropTypes.bool,
  subHeading: PropTypes.string,
  subHeadingMobile: PropTypes.string,
  subHeadingLTE: PropTypes.string,
  location: PropTypes.object,
  subHeadingPreorder: PropTypes.string,
  cradleSubHeading: PropTypes.string,
  isCradleFlow: PropTypes.bool,
  totalDueTodayAmount: PropTypes.any,
  pageName: PropTypes.string,
  dueTodayText: PropTypes.string,
};
SubHeading.defaultProps = {
  bold: false,
  size: 'bodyLarge',
};

export default SubHeading;
